import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, Dropdown } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../layout/components/helpers/Translator';
import Sidebar from '../../../../layout/Sidebar/Sidebar';
import AppModal from '../../../../layout/components/Modal/AppModal';
import { path, axiosPath } from '../../../../routing/helpers/router';
import BreadcrumbHandler from '../../../../layout/components/breadcrumb/BreadcrumbHandler';
import SidebarButton from '../../../../layout/Sidebar/SidebarButton';
import useIsMounted from '../../../../layout/components/hooks/useIsMounted';
import { AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import _ from 'lodash';

const ModuleSaicaReportHomeScreen = () => {
  const { moduleBridgeHex, level } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMounted = useIsMounted();
  const global = useSelector((state) => state.global);
  const [module, setModule] = useState(null);
  const [initializeReportModal, setInitializeReportModal] = useState();
  const [loading, setLoading] = useState(true);
  const [showInitializeReportModal, setShowInitializeReportModal] =
    useState(false);

  const [filters, setFilters] = useState({
    name: '',
    year: null,
    period: null,
    status: null,
  });
  const [filterName, setFilterName] = useState('');
  const [filterYear, setFilterYear] = useState(null);
  const [filterPeriod, setFilterPeriod] = useState(null);
  const [filterStatus, setFilterStatus] = useState(null);
  const [actualFilters, setActualFilters] = useState({
    name: '',
    year: null,
    period: null,
    status: null,
  });

  let i;
  const years = [];
  const actualYear = new Date().getFullYear();
  for (i = 2020; i <= actualYear; i++) {
    years.push(i);
  }

  // > LOAD MODULE
  const loadModule = useCallback(async () => {
    try {
      const response = await axios.post(
        axiosPath('api_r_user_module_saicaReports_home'),
        { moduleBridgeHex, filters, level },
      );
      return response.data;
    } catch (err) {}
  });

  useEffect(() => {
    loadModule().then((response) => {
      if (isMounted.current) {
        setLoading(false);
        setModule(response);
      }
    });
  }, [moduleBridgeHex, level, filters]);

  const redirectToLevel = (lvl) => {
    setLoading(true);
    navigate(
      path({
        name: 'user_module_saicaReport_home',
        params: { moduleBridgeHex, level: lvl },
      }),
    );
  };
  // < LOAD MODULE

  // > INITIALIZE REPORT
  const handleInitialiceReport = async (r) => {
    try {
      setShowInitializeReportModal(true);
      setInitializeReportModal(r);
      const response = await axios.post(
        axiosPath('api_r_user_module_saicaReports_initializeReport'),
        { moduleBridgeHex, report: r, languageSlug: global.urlData.lang },
      );
      navigate(
        path({
          name: 'user_module_saicaReport_report',
          params: { moduleBridgeHex, reportHex: response.data.reportHex },
        }),
      );
    } catch (err) {}
  };
  // < INITIALIZE REPORT

  // > FILTERS
  const handleFilters = () => {
    const newFilters = {
      name: filterName,
      year: filterYear,
      period: filterPeriod,
      status: filterStatus,
    };
    if (!_.isEqual(newFilters, actualFilters)) {
      setActualFilters(newFilters);
      setLoading(true);
      setFilters(newFilters);
    }
  };
  const handleRemoveFilters = () => {
    const newFilters = {
      name: '',
      year: null,
      period: null,
      status: null,
    };
    setFilterName('');
    setFilterYear(null);
    setFilterPeriod(null);
    setFilterStatus(null);
    setActualFilters(newFilters);
    setLoading(true);
    setFilters(newFilters);
  };
  // < FILTERS

  return (
    <div className="pl-2">
      <div className="content-header">
        <BreadcrumbHandler paths={[{ name: 'Report list' }]} />
      </div>
      <section className="content">
        <Sidebar>
          <Accordion>
            <ul>
              <li onClick={() => redirectToLevel(1)}>
                <SidebarButton
                  icon={<b>1</b>}
                  title={
                    <Translator file="module-saicaReports" name="tier.1" />
                  }
                />
              </li>
              <li onClick={() => redirectToLevel(2)}>
                <SidebarButton
                  icon={<b>2</b>}
                  title={
                    <Translator file="module-saicaReports" name="tier.2" />
                  }
                />
              </li>
              <li onClick={() => redirectToLevel(3)}>
                <SidebarButton
                  icon={<b>3</b>}
                  title={
                    <Translator file="module-saicaReports" name="tier.3" />
                  }
                />
              </li>
              <li onClick={() => redirectToLevel(4)}>
                <SidebarButton
                  icon={<b>4</b>}
                  title={
                    <Translator file="module-saicaReports" name="tier.4" />
                  }
                />
              </li>
            </ul>
          </Accordion>
        </Sidebar>
        <div className="row">
          <div className="col-12">
            <h3>
              <Translator file="module-saicaReports" name="reporting.tier" />
              {level}
            </h3>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control"
                style={{ height: '44px' }}
                placeholder={ReactDOMServer.renderToString(
                  <Translator
                    file="module-saicaReports"
                    name="filter.by.plan.site"
                  />,
                )}
                value={filterName}
                onChange={(e) => setFilterName(e.target.value)}
              />
              <Dropdown
                className="input-group-append btn btn-xs btn-outline-light"
                onSelect={(e) => setFilterYear(e)}
              >
                <Dropdown.Toggle variant="default" id="dropdown-basic">
                  {!filterYear || filterYear === 'all' ? (
                    <Translator file="module-saicaReports" name="all.years" />
                  ) : (
                    filterYear
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    eventKey="all"
                    active={!filterYear || filterYear === 'all'}
                  >
                    <Translator file="module-saicaReports" name="all.years" />
                  </Dropdown.Item>
                  {years.map((y, i) => (
                    <Dropdown.Item
                      key={i}
                      eventKey={y}
                      active={filterYear === y.toString()}
                    >
                      {y}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown
                className="input-group-append btn btn-xs btn-outline-light"
                onSelect={(e) => setFilterPeriod(e)}
              >
                <Dropdown.Toggle variant="default" id="dropdown-basic">
                  {!filterPeriod || filterPeriod === 'all' ? (
                    <Translator file="module-saicaReports" name="all.periods" />
                  ) : filterPeriod === '0' ? (
                    <Translator
                      file="module-saicaReports"
                      name="january.june"
                    />
                  ) : (
                    <Translator
                      file="module-saicaReports"
                      name="july.december"
                    />
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    eventKey="all"
                    active={!filterPeriod || filterPeriod === 'all'}
                  >
                    <Translator file="module-saicaReports" name="all.periods" />
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="0" active={filterPeriod === '0'}>
                    <Translator
                      file="module-saicaReports"
                      name="january.june"
                    />
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="1" active={filterPeriod === '1'}>
                    <Translator
                      file="module-saicaReports"
                      name="july.december"
                    />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown
                className="input-group-append btn btn-xs btn-outline-light"
                onSelect={(e) => setFilterStatus(e)}
              >
                <Dropdown.Toggle variant="default" id="dropdown-basic">
                  {!filterStatus || filterStatus === 'all' ? (
                    <Translator file="module-saicaReports" name="all.status" />
                  ) : filterStatus === '0' ? (
                    <Translator file="module-saicaReports" name="pending" />
                  ) : filterStatus === '1' ? (
                    <Translator file="module-saicaReports" name="overdue" />
                  ) : filterStatus === '2' ? (
                    <Translator file="module-saicaReports" name="in.progress" />
                  ) : (
                    filterStatus === '3' && (
                      <Translator file="module-saicaReports" name="complete" />
                    )
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    eventKey="all"
                    active={!filterStatus || filterStatus === 'all'}
                  >
                    <Translator file="module-saicaReports" name="all.status" />
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="0" active={filterStatus === '0'}>
                    <Translator file="module-saicaReports" name="pending" />
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="1" active={filterStatus === '1'}>
                    <Translator file="module-saicaReports" name="overdue" />
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="2" active={filterStatus === '2'}>
                    <Translator file="module-saicaReports" name="in.progress" />
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="3" active={filterStatus === '3'}>
                    <Translator file="module-saicaReports" name="complete" />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {(filters.name ||
                filters.year ||
                filters.period ||
                filters.status) && (
                <div
                  className="input-group-append"
                  onClick={() => handleRemoveFilters()}
                >
                  <span className="btn btn-danger">
                    <AppRemixIcon icon="delete-bin" />
                  </span>
                </div>
              )}
              <div
                className="input-group-append"
                onClick={() => handleFilters()}
              >
                <span className="btn btn-info">
                  <Translator file="module-saicaReports" name="filter" />
                </span>
              </div>
            </div>
          </div>
        </div>
        {loading === true ? (
          <AppNoInfo />
        ) : (
          module && (
            <div className="row">
              <div className="col-12">
                <div className="card sr-header">
                  <div className="card-body">
                    {module.reports.length > 0 ? (
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th style={{ width: '58.34%' }}>
                              <Translator
                                file="module-saicaReports"
                                name="plan.site"
                              />
                            </th>
                            <th style={{ width: '15%' }}>
                              <Translator
                                file="module-saicaReports"
                                name="year"
                              />
                            </th>
                            <th style={{ width: '15%' }}>
                              <Translator
                                file="module-saicaReports"
                                name="months"
                              />
                            </th>
                            <th style={{ width: '12.66%' }}>
                              <Translator
                                file="module-saicaReports"
                                name="status"
                              />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {module.reports.map((rep, i) => (
                            <tr key={i}>
                              {rep.existing === true ? (
                                <td>
                                  <Link
                                    to={path({
                                      name: 'user_module_saicaReport_report',
                                      params: {
                                        moduleBridgeHex,
                                        reportHex: rep.hex,
                                      },
                                    })}
                                  >
                                    {rep.plantGroup.masterPlant.name}
                                  </Link>
                                </td>
                              ) : (
                                <td>
                                  <span>{rep.plantGroup.masterPlant.name}</span>
                                  <span
                                    className="btn btn-info float-right"
                                    onClick={() => handleInitialiceReport(rep)}
                                  >
                                    <AppRemixIcon icon="play" />
                                    <Translator
                                      file="module-saicaReports"
                                      name="initialize"
                                    />
                                  </span>
                                </td>
                              )}
                              <td>{rep.year}</td>
                              <td>
                                {rep.period === 0 ? (
                                  <Translator
                                    file="module-saicaReports"
                                    name="january.june"
                                  />
                                ) : (
                                  <Translator
                                    file="module-saicaReports"
                                    name="july.december"
                                  />
                                )}
                              </td>
                              <td>
                                {rep.status === 0 && (
                                  <span className="btn btn-outline-light btn-block">
                                    <Translator
                                      file="module-saicaReports"
                                      name="pending"
                                    />
                                  </span>
                                )}
                                {rep.status === 1 && (
                                  <span className="btn btn-danger btn-block">
                                    <Translator
                                      file="module-saicaReports"
                                      name="overdue"
                                    />
                                  </span>
                                )}
                                {rep.status === 2 && (
                                  <span className="btn btn-warning btn-block">
                                    <Translator
                                      file="module-saicaReports"
                                      name="in.progress"
                                    />
                                  </span>
                                )}
                                {rep.status === 3 && (
                                  <span className="btn btn-success btn-block">
                                    <Translator
                                      file="module-saicaReports"
                                      name="complete"
                                    />
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="alert alert-info">
                        <Translator
                          file="module-saicaReports"
                          name="no.results"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        )}
      </section>
      <AppModal size="lg" show={showInitializeReportModal}>
        <AppNoInfo />
      </AppModal>
    </div>
  );
};

export default ModuleSaicaReportHomeScreen;
